// extracted by mini-css-extract-plugin
module.exports = {"basicTextFilterWrapper":"-basic-text-filter-basicTextFilterWrapper-3Jx71c-"};